<template>
  <el-popover placement="top" width="400" v-model="visible" @show="show">
    <el-input :value="value" @input="inputChange"></el-input>
    <div style="text-align: right; margin: 10px 0 0 0">
      <el-button size="mini" type="text" @click="visible = false"
        >取消</el-button
      >
      <el-button type="primary" size="mini" @click="submitPopover"
        >确定</el-button
      >
    </div>
    <div slot="reference">
      <span>{{ row[prop] }}</span>
      <i class="el-icon-edit" style="margin-left: 10px"></i>
    </div>
  </el-popover>
</template>

<script>
export default {
  props: {
    row: Object,
    prop: String,
  },
  data() {
    return {
      visible: false,
      showIcon: false,
      value: "",
    };
  },
  methods: {
    show() {
      this.value = this.row[this.prop];
    },
    inputChange(e) {
      this.value = e.trim();
    },
    submitPopover() {
      this.visible = false;
      if (!this.value.trim()) return;
      this.$emit("orderNoChange", this.row, this.prop, this.value);
    },
  },
};
</script>
